import React, { useEffect, useState, useRef } from 'react';
import InputBoxes from '../StockSalesGraph/inputBoxes'
import { Graph } from './graph';

export const StockSalesTimeGraphView = (props) => {
  const [orderBy, setOrderBy] = useState("combinedStockValue");

  const [groupBy, setGroupBy] = useState('productBrand');
  const [visibleSeries, setVisibleSeries] = useState({
    totalCostValueGoodsSold: true,
    merchoidStockValue: true,
    sellingPriceGbp: false,
    totalProfit: false,
    aaaSales: true,
    aaaStockValue: true
  });


  useEffect(() => {
    const getUniqueValues = (key) => {
      if (key === 'allItems') {
        return ['All Items'];
      }
      return Array.from(new Set(props.stock.map((item) => item[key])));
    };
    let categories = [];
    if (groupBy === 'productBrand') {
      categories = getUniqueValues('productBrand');
    } else if (groupBy === 'supplierCode') {
      categories = getUniqueValues('supplierCode');
    } else if (groupBy === 'productCategory') {
      categories = getUniqueValues('productCategory');
    } else if (groupBy === 'allItems') {
      categories = getUniqueValues('allItems');
    }

    // if (categories) {
    //   categories.sort();
    // }




    const merchoidSales = props.merchoidSales;
    const aaaSales = props.aaaSales
    const stockData = props.stock;


    const seriesDataSales = [];
    const aaaSeriesDataSales = []
    const seriesDataStockCost = [];
    const aaaSeriesDataStockValue = [];
    const seriesDataProfit = [];
    const aaaSeriesDataProfit = []
    const seriesDataSellingPriceGbp = [];
    const aaaSeriesDataSellingPriceGbp = []

    categories.forEach((category) => {
      let totalSalesPrice = 0;
      let merchoidStockValue = 0;
      let totalProfit = 0;
      let totalSellingPriceGbp = 0;
      let totalAaaSales = 0;
      let aaaTotalSalesPrice = 0
      let aaaTotalProfit = 0
      let aaaTotalSellingPriceGbp = 0
      let aaaTotalStockValue = 0

      if (category === 'All Items') {
        merchoidSales.forEach((item) => {
          totalSalesPrice += item.costPrice
          totalProfit += item.profit <= -9000 ? 0 : item.profit
          totalSellingPriceGbp += item.sellingPriceGbp
        });

        aaaSales.forEach((item) => {
          aaaTotalSalesPrice += item.costPrice
          aaaTotalProfit += item.profit
          aaaTotalSellingPriceGbp += item.sellingPriceGbp
        });

        //calculate merhcoid stock value
        stockData.forEach((item) => {
          const latestQtyByDate = item.qtyByDate[item.qtyByDate.length - 1];
          if (latestQtyByDate && latestQtyByDate.length >= 1 && latestQtyByDate[1] !== null) {
            if (latestQtyByDate && latestQtyByDate[0]) {
              const qty = latestQtyByDate[1];
              merchoidStockValue += qty * item.productCost
            }
          }


          //calculate total aaa stock value
          if (item.aaaQtyByDate) {
            const aaaLatestQtyByDate = item.aaaQtyByDate[item.aaaQtyByDate.length - 1];
            if (aaaLatestQtyByDate && aaaLatestQtyByDate.length >= 1 && aaaLatestQtyByDate[1] !== null) {
              if (aaaLatestQtyByDate && aaaLatestQtyByDate[0]) {
                const qty = aaaLatestQtyByDate[1];
                aaaTotalStockValue += qty * item.aaaCostPrice
              }
            }
          }


        });
      } else {
        merchoidSales.forEach((item) => {
          if (item[groupBy] === category) {
            totalSalesPrice += item.costPrice;
            totalProfit += item.profit <= -9000 ? 0 : item.profit;
            totalSellingPriceGbp += item.sellingPriceGbp;
          }
        });

        aaaSales.forEach((item) => {
          if (item[groupBy] === category) {
            aaaTotalSalesPrice += item.costPrice;
            aaaTotalProfit += item.profit <= -9000 ? 0 : item.profit;
            aaaTotalSellingPriceGbp += item.sellingPriceGbp;
          }
        });


        stockData.forEach((item) => {
          if (item[groupBy] === category) {
            const latestQtyByDate = item.qtyByDate[item.qtyByDate.length - 1];
            if (latestQtyByDate && !isNaN(latestQtyByDate[1])) {
              const qty = Number(latestQtyByDate[1])
              merchoidStockValue += parseFloat(qty) * parseFloat(item.productCost);
            }


            //calculate total aaa stock value
            if (item.aaaQtyByDate) {
              const aaaLatestQtyByDate = item.aaaQtyByDate[item.aaaQtyByDate.length - 1];
              if (aaaLatestQtyByDate && aaaLatestQtyByDate.length >= 1 && aaaLatestQtyByDate[1] !== null) {
                if (aaaLatestQtyByDate && aaaLatestQtyByDate[0]) {

                  const qty = Number(aaaLatestQtyByDate[1]);
                  aaaTotalStockValue += parseFloat(qty) * parseFloat(item.aaaCostPrice)

                }
              }
            }


          }
        });
      }
      seriesDataProfit.push(totalProfit.toFixed(2));
      aaaSeriesDataProfit.push(aaaTotalProfit.toFixed(2))

      seriesDataSales.push(totalSalesPrice.toFixed(2));
      aaaSeriesDataSales.push(aaaTotalSalesPrice.toFixed(2))

      seriesDataStockCost.push(merchoidStockValue.toFixed(2));
      aaaSeriesDataStockValue.push(aaaTotalStockValue.toFixed(2));
      seriesDataSellingPriceGbp.push(totalSellingPriceGbp.toFixed(2))
      aaaSeriesDataSellingPriceGbp.push(aaaTotalSellingPriceGbp.toFixed(2))
    });



  }, [props.merchoidSales, props.aaaSales, props.stock, groupBy, visibleSeries, orderBy]);

  const handleGroupByChange = (event) => {
    setGroupBy(event.target.value);
  };


  return <div>
    <select disabled={props.loading} value={props.startDateDaysFromNow} onChange={(e) => props.onChangeStartDate(e)}>
      <option value="30">30 days</option>
      <option value="60">60 days</option>
      <option value="90">90 days</option>
      <option value="180">180 days</option>
      <option value="365">365 days</option>
    </select>

    <select onChange={handleGroupByChange}>
      <option value="productBrand">Brand</option>
      <option value="supplierCode">Supplier</option>
      <option value="productCategory">Category</option>
      <option value="allItems">All Items</option>
    </select>
    {!props.loading && <Graph
      merchoidStock={props.stock}
    />}
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>

    <div>
      <InputBoxes
        setExclusions={props.setExclusions}
        setIsInclusion={props.setIsInclusion}
        isInclusion={props.isInclusion}
        isBadStockBool={props.isBadStockBool}
        setIsBadStockBool={props.setIsBadStockBool}
        onToggleBadStock={props.onToggleBadStock}
      />
    </div>








  </div>


}



